
export const SET_PROFILE_DATA = "SET_PROFILE_DATA";
export const SET_ROLE_CLAIMS = "SET_ROLE_CLAIMS";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_TOKEN_CLAIMS = "SET_TOKEN_CLAIMS";

